import {
  type ExperimentProgressRunContext
} from "./experimentProgressPresentation.js";

export function ExperimentProgressIntro({
  context
}: {
  context: ExperimentProgressRunContext | null;
}) {
  if (!context) return null;
  const fullText = `${context.title} — ${context.text}${context.metric ? ` · ${context.metric.name}: ${context.metric.display}` : ""}`;
  return <div className="experiment-progress-intro" title={fullText}>
    <p><strong>{context.title}</strong><span> — {context.text}</span></p>
    {context.metric ? <code>{context.metric.display}</code> : null}
  </div>;
}
